<template>
  <div class="replacementmonthlystatistics__report__view">
    <div class="reports__subheader">
      <year-panel @year="(value) => (year = value)"> </year-panel>

      <employees-panel
        @employeeId="(value) => (employeeId = value)"
        :employeeNumber="employeeNumber"
        v-if="isAdmin"
      >
      </employees-panel>

      <submit-panel @submit="performLookup"> </submit-panel>
    </div>

    <b-table
      :data="groups"
      ref="table"
      detailed
      hoverable
      custom-detail-row
      :loading="loading"
    >
      <b-table-column
        field="subType"
        label="Type"
        v-slot="props"
        sortable
        centered
      >
        <template>
          <a @click="toggle(props.row)">
            {{ props.row.subType }}
          </a>
        </template>
      </b-table-column>
      <b-table-column
        field="timeInMinutes"
        label="ATK tid (timer)"
        v-slot="props"
        sortable
        numeric
      >
        {{ (props.row.timeInMinutes / 60.0) | twodecimal }}
      </b-table-column>
      <b-table-column
        field="timeInMinutesSH"
        label="ATK tid (timer) (sh)"
        v-slot="props"
        sortable
        numeric
      >
        {{ (props.row.timeInMinutesSH / 60.0) | twodecimal }}
      </b-table-column>
      <b-table-column
        field="days"
        label="ATK dage"
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.days }}
      </b-table-column>
      <b-table-column
        field="daysSH"
        label="ATK dage (sh)"
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.daysSH }}
      </b-table-column>
      <b-table-column
        field="timeInMinutesRTA"
        label="RTA tid (timer)"
        v-slot="props"
        sortable
        numeric
      >
        {{ (props.row.timeInMinutesRTA / 60.0) | twodecimal }}
      </b-table-column>
      <b-table-column
        field="timeInMinutesRTASH"
        label="RTA tid (timer) (sh)"
        v-slot="props"
        sortable
        numeric
      >
        {{ (props.row.timeInMinutesRTASH / 60.0) | twodecimal }}
      </b-table-column>
      <b-table-column
        field="daysRTA"
        label="RTA dage"
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.daysRTA }}
      </b-table-column>
      <b-table-column
        field="daysRTASH"
        label="RTA dage (sh)"
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.daysRTASH }}
      </b-table-column>
      <b-table-column
        field="timeInMinutesABK"
        label="ABK før 7:15"
        v-slot="props"
        sortable
        numeric
        v-if="showABK"
      >
        {{ (props.row.timeInMinutesABK / 60.0) | twodecimal }}
      </b-table-column>
      <b-table-column
        field="timeInMinutesSHABK"
        label="ABK før 7:15 (sh)"
        v-slot="props"
        sortable
        numeric
        v-if="showABK"
      >
        {{ (props.row.timeInMinutesSHABK / 60.0) | twodecimal }}
      </b-table-column>
      <b-table-column
        field="timeInMinutesPassenger"
        label="Passenger tid (timer)"
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.timeInMinutesPassenger }}
      </b-table-column>
      <b-table-column
        field="timeInMinutesPassengerSH"
        label="Passenger tid (timer) (sh)"
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.timeInMinutesPassengerSH }}
      </b-table-column>
      <b-table-column
        field="daysPassenger"
        label="Passenger dage"
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.daysPassenger }}
      </b-table-column>
      <b-table-column
        field="daysPassengerSH"
        label="Passenger dage (sh)"
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.daysPassengerSH }}
      </b-table-column>

      <template slot="detail" slot-scope="props">
        <tr v-for="item in props.row.items" :key="item.remarks">
          <td style="width: 100px">{{ item.createdDate | formatDate }}</td>
          <td>{{ item.remark }}</td>
          <td style="text-align: right;">
            {{ (item.timeInMinutes / 60.0) | twodecimal }}
          </td>
          <td style="text-align: right;">
            {{ (item.timeInMinutesSH / 60.0) | twodecimal }}
          </td>
          <td style="text-align: right;">{{ item.days }}</td>
          <td style="text-align: right;">{{ item.daysSH }}</td>
          <td style="text-align: right;">
            {{ (item.timeInMinutesRTA / 60.0) | twodecimal }}
          </td>
          <td style="text-align: right;">
            {{ (item.timeInMinutesRTASH / 60.0) | twodecimal }}
          </td>
          <td style="text-align: right;">{{ item.daysRTA }}</td>
          <td style="text-align: right;">{{ item.daysRTASH }}</td>
          <td style="text-align: right;" v-if="showABK">
            {{ (item.timeInMinutesABK / 60.0) | twodecimal }}
          </td>
          <td style="text-align: right;" v-if="showABK">
            {{ (item.timeInMinutesSHABK / 60.0) | twodecimal }}
          </td>
          <td style="text-align: right;">
            {{ (item.timeInMinutesPassenger / 60.0) | twodecimal }}
          </td>
          <td style="text-align: right;">
            {{ (item.timeInMinutesPassengerSH / 60.0) | twodecimal }}
          </td>
          <td style="text-align: right;">{{ item.daysPassenger }}</td>
          <td style="text-align: right;">{{ item.daysPassengerSH }}</td>
        </tr>
      </template>
    </b-table>
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="saving"
      :can-cancel="true"
    ></b-loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from "@/enums/APISTATE";
import SubmitPanel from "@/components/report/SubmitPanel.vue";
import YearPanel from "@/components/report/YearPanel.vue";
import EmployeesPanel from "@/components/report/EmployeesPanel.vue";

export default {
  name: "yearly-timeregistration-report-view",
  components: { SubmitPanel, YearPanel, EmployeesPanel },
  props: {
    employeeNumber: {
      type: Number,
      required: undefined,
    },
  },
  data: () => ({
    year: undefined,
    employeeId: undefined,
    saving: false,
    isFullPage: true,
  }),
  async mounted() {
    await this.$store.dispatch("metadata/initialize");

    if (this.isAdmin === false) {
      this.employeeId = this.currentUser.id;
    }
  },
  methods: {
    ...mapActions("reportStore", ["getYearlyReport"]),
    async performLookup() {
      const dto = {
        year: this.year,
        forUser: this.employeeId,
      };
      await this.getYearlyReport(dto);
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    },
  },
  computed: {
    ...mapGetters("reportStore", ["yearlyReportApiState", "yearlyReport"]),
    ...mapGetters("metadata", ["allocationTypes", "allocationTypesReport"]),
    ...mapGetters(["currentUser", "isAdmin", "hasEditRights"]),
    loading() {
      return this.yearlyReportApiState === APISTATE.LOADING;
    },
    groups() {
      if (this.yearlyReport) {
        const groups = [];
        this.yearlyReport.forEach((element) => {
          const current = groups.find((f) => f.subType === element.subType);
          if (current) {
            current.days += element.days;
            current.daysPassenger += element.daysPassenger;
            current.daysRTA += element.daysRTA;
            current.timeInMinutes += element.timeInMinutes;
            current.timeInMinutesSH += element.timeInMinutesSH;
            current.timeInMinutesPassenger += element.timeInMinutesPassenger;
            current.timeInMinutesPassengerSH += element.timeInMinutesPassengerSH;
            current.daysPassengerSH += element.daysPassengerSH;
            current.daysRTASH += element.daysRTASH;
            current.daysSH += element.daysSH;
            current.timeInMinutesRTASH += element.timeInMinutesRTASH;
            current.timeInMinutesRTA += element.timeInMinutesRTA;
            current.timeInMinutesABK += element.timeInMinutesABK;
            current.timeInMinutesSHABK += element.timeInMinutesSHABK;
            current.items.push(element);
          } else {
            groups.push({
              subType: element.subType,
              days: element.days,
              daysPassenger: element.daysPassenger,
              daysPassengerSH: element.daysPassengerSH,
              daysRTA: element.daysRTA,
              daysRTASH: element.daysRTASH,
              daysSH: element.daysSH,
              remark: element.remark,
              timeInMinutes: element.timeInMinutes,
              timeInMinutesSH: element.timeInMinutesSH,
              timeInMinutesPassenger: element.timeInMinutesPassenger,
              timeInMinutesPassengerSH: element.timeInMinutesPassengerSH,
              timeInMinutesRTA: element.timeInMinutesRTA,
              timeInMinutesRTASH: element.timeInMinutesRTASH,
              timeInMinutesABK: element.timeInMinutesABK,
              timeInMinutesSHABK: element.timeInMinutesSHABK,
              items: [element],
            });
          }
        });

        groups.push({
          subType: "Total",
          days: groups.reduce((acc, item) => acc + item.days, 0),
          daysSH: groups.reduce((acc, item) => acc + item.daysSH, 0),
          daysPassenger: groups.reduce((acc, item) => acc + item.daysPassenger, 0),
          daysPassengerSH: groups.reduce((acc, item) => acc + item.daysPassengerSH, 0),
          daysRTA: groups.reduce((acc, item) => acc + item.daysRTA, 0),
          daysRTASH: groups.reduce((acc, item) => acc + item.daysRTASH, 0),
          remark: "",
          timeInMinutes: groups.reduce((acc, item) => acc + item.timeInMinutes, 0),
          timeInMinutesSH: groups.reduce((acc, item) => acc + item.timeInMinutesSH, 0),
          timeInMinutesPassenger: groups.reduce((acc, item) => acc + item.timeInMinutesPassenger, 0),
          timeInMinutesPassengerSH: groups.reduce((acc, item) => acc + item.timeInMinutesPassengerSH, 0),
          timeInMinutesRTA: groups.reduce((acc, item) => acc + item.timeInMinutesRTA, 0),
          timeInMinutesRTASH: groups.reduce((acc, item) => acc + item.timeInMinutesRTASH, 0),
          timeInMinutesABK: groups.reduce((acc, item) => acc + item.timeInMinutesABK, 0),
          timeInMinutesSHABK: groups.reduce((acc, item) => acc + item.timeInMinutesSHABK, 0),
          items: [],
        });
        return groups;
      }
      return null;
    },
    showABK() {
      return this.isReplacement || this.isAdmin;
    },
  },
};
</script>

<style lang="scss" scoped>
.b-table {
  font-size: 12px;
}
</style>
